import { toApiStatus } from '@/api/mappers/mapStatus';
import {
  Organization as ApiOrganization,
  OrganizationCreateRequest,
  OrganizationUpdateRequest,
} from '@/gen/api';
import {
  Organization,
  OrganizationCreate,
  Organization as OrganizationModel,
} from '@/models/Organization';

export const toOrganization = (apiOrganization: ApiOrganization): OrganizationModel => {
  return {
    ...apiOrganization,
    id: apiOrganization.id as string,
    createdAt: apiOrganization.createdAt || new Date(0),
  };
};

export const toApiOrganization = (org: Organization): ApiOrganization => {
  return {
    ...org,
    status: toApiStatus(org.status),
  };
};

// Convert OrganizationCreate model to API OrganizationCreateRequest
export const toApiOrganizationCreateRequest = (
  orgCreate: OrganizationCreate,
): OrganizationCreateRequest => {
  return {
    ...orgCreate,
    status: toApiStatus(orgCreate.status),
  };
};

// Convert Organization model to API OrganizationUpdateRequest
export const toApiOrganizationUpdateRequest = (org: Organization): OrganizationUpdateRequest => {
  return {
    ...org,
    status: toApiStatus(org.status),
  };
};
